const lineClampClasses = {
    1: 'line-clamp-1',
    2: 'line-clamp-2',
    3: 'line-clamp-3',
    4: 'line-clamp-4',
    5: 'line-clamp-5',
    8: 'line-clamp-[8]',
};

import { Controller } from '@hotwired/stimulus';

/* stimulusFetch: 'lazy' */
export default class extends Controller {
    static targets = ['text', 'button'];
    static values = {
        lines: { type: Number, default: 3 },
    };

    connect() {
        this.textTarget.classList.add(lineClampClasses[this.linesValue]);

        this.buttonTarget.innerText = 'Voir plus';

        this.observer = new IntersectionObserver(
            (entries) => {
                if (entries[0].isIntersecting) {
                    this.checkOverflow();
                    this.observer.disconnect();
                }
            },
            { rootMargin: '120px' },
        );
        this.observer.observe(this.element);
    }

    checkOverflow() {
        if (this.textTarget.scrollHeight > this.textTarget.clientHeight) {
            this.buttonTarget.classList.remove('hidden');
        } else {
            this.buttonTarget.classList.add('hidden');
        }
    }

    toggle() {
        const isClamped = this.textTarget.classList.contains(
            lineClampClasses[this.linesValue],
        );

        if (isClamped) {
            this.textTarget.classList.remove(lineClampClasses[this.linesValue]);
            this.buttonTarget.innerText = 'Voir moins';
        } else {
            this.textTarget.classList.add(lineClampClasses[this.linesValue]);
            this.buttonTarget.innerText = 'Voir plus';
        }
    }
}
